import { FormFieldTypes, validationTypes } from "@repo/design-system/components/forms/libs";

export const passwordFormConfig = {
    name: "Password Verification Form",
    initialState: { password: "" },
    section: [
        {
            title: "",
            rowGroup: [
                {
                    style: { groupStyle: "row" },
                    fields: [
                        {
                            id: "password",
                            label: "Password",
                            Field_Name: "password",
                            fieldType: FormFieldTypes.PASSWORD,
                            dataField: "password",
                            fieldSetting: {
                                placeholder: "Enter password",
                            },
                            validation: [{ type: validationTypes.REQUIRE }],
                            style: { containerCss: "col-md-12 mb-3" },
                        },
                    ],
                },
            ],
        },
    ],
};
